import { Checkbox, Icon } from "semantic-ui-react";

import { APPOINTMENT_REPORT_SECTION_TYPE } from "modules/AppointmentDetails/components/AppointmentReportDropdown/hooks";

import type { CheckOption, LogOption } from "modules/AppointmentDetails/components/AppointmentReportDropdown/hooks";
import type { FormEvent } from "react";

type DropdownOption = CheckOption | LogOption;

type DropdownItemProps = {
  option: DropdownOption;
  checked: boolean;
  onChange: (event: FormEvent) => void;
};

export const DropdownItem = ({ option, checked, onChange }: DropdownItemProps) => {
  if (option.sectionType === APPOINTMENT_REPORT_SECTION_TYPE.Check) {
    return (
      <div className="appointment-report-dropdown-option appointment-report-dropdown-item" onClick={e => e.stopPropagation()}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          label={
            <label>
              <Icon className={option.icon} />
              {option.text}
            </label>
          }
        />
      </div>
    );
  }

  return (
    <div className="appointment-report-dropdown-option appointment-report-dropdown-item" onClick={e => e.stopPropagation()}>
      <Checkbox
        checked={checked}
        onChange={onChange}
        label={
          <label>
            {option.isCompositeIcon ? (
              <div className="composite-icons">
                <Icon name="user" />
                <Icon name="clock outline" />
              </div>
            ) : (
              <Icon name="user" />
            )}
            {option.text}
          </label>
        }
      />
    </div>
  );
};
